// extracted by mini-css-extract-plugin
module.exports = {"badge":"badges_badge__u76Bz","truncate":"badges_truncate__LxrEj","icon":"badges_icon__tad4p"};